import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Modal } from 'reactstrap'


class ConfirmModal extends Component {
  static propTypes = {
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    btnClassName: PropTypes.string,
    btnLabel: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string,
  }

  state = {
    modal: false
  }

  toggle = () => {
    this.setState(({ modal }) => ({ modal: !modal }))
  }

  onConfirm = e => {
    this.props.onConfirm(e);
    this.toggle();
  }

  render() {
    const { body, title, btnClassName, btnLabel } = this.props
    const { modal } = this.state

    return (
      <span className="confirm">
        <button className={classNames('btn', { [btnClassName]: btnClassName })} onClick={this.toggle} disabled={modal}>
          { btnLabel }
        </button>
        <Modal isOpen={modal} toggle={this.toggle}>
          <div className="modal-content">
            {
              title && (
                <div className="modal-header">
                  <h4 className="modal-title">{ title }</h4>
                </div>
              )
            }
            <div className="modal-body">
              { body }
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary mr-2" onClick={this.onConfirm}>Confirm</button>
              <button className="btn" onClick={this.toggle}>Cancel</button>
            </div>
          </div>
        </Modal>
      </span>
    )
  }
}

export default ConfirmModal



// WEBPACK FOOTER //
// ./src/components/common/confirm-modal.js